import { getAPIFullUrl, getAxiosConfig, handleApiError } from './risapi';
import { risapi } from './risapi';

/**
 * Fetches all summary data for the dashboard.
 */
export const getDashboardSummary = async (callback) => {
    try {
        const response = await risapi.get('/api/dashboard-summary', getAxiosConfig());
        if (response.status === 200) {
            callback(response.data);
        }
    } catch (error) {
        handleApiError(error);
        callback({ error });
    }
};